import { NgModule, ModuleWithProviders, Provider } from '@angular/core';

import { AppComponent } from './app.component';
import {
  CacheService,
  ImageProviderService,
  LoggerService,
  NotificationHandlerService,
  ModuleConfigService,
  MiningToastService,
  MiningToastManagerService,
} from './services';
import { ButtonComponent, ButtonIconComponent, ButtonStateComponent, AnimatedActionButtonComponent } from './components/buttons';
import { LangPipe, PascalCase } from './pipes';
import { LangInterceptorService } from './services/interceptors';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MiningToastComponent } from './components/mining-toast/mining-toast.component';
import { ImageSelectorDirective } from './directives';
import { TwoOptionModalComponent } from './components/two-option-modal/two-option-modal.component';
import { MainTableComponent } from './components/table/main-table/main-table.component';
import { DataTableComponent } from './components/table/data-table/data-table.component';
import { RegisterPerPageComponent } from './components/table/register-per-page/register-per-page.component';
import { PaginatorComponent } from './components/table/paginator/paginator.component';
import { HeaderTableComponent } from './components/table/header-table/header-table.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InputComponent } from './components/input/input.component';
import { TagDirective } from './directives/tag.directive';
import { CharRestrictionDirective } from './directives/char-restriction.directive';
import { DropdownSelectorComponent } from './components/dropdown-selector/dropdown-selector.component';
import { NoCommaPipe } from './pipes/no-comma.pipe';
import { SwitchButtonComponent } from './components/switch-button/switch-button.component';
import { DataCyDirective } from './directives/data-cy.directive';
import { MtContainerComponent } from './components/mt-container/mt-container.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { TruncateTooltipDirective } from './directives/truncate-tooltip.directive';

const BUTTONS = [ButtonComponent, ButtonIconComponent, ButtonStateComponent, AnimatedActionButtonComponent];

const PIPES = [LangPipe, PascalCase];

const COMPONENTS = [
  ...BUTTONS,
  MiningToastComponent,
  TwoOptionModalComponent,
  MainTableComponent,
  InputComponent,
  DropdownSelectorComponent,
  SwitchButtonComponent,
  MtContainerComponent,
  TextareaComponent,
];

const DIRECTIVES = [ImageSelectorDirective, TagDirective, CharRestrictionDirective, NoCommaPipe, DataCyDirective, TruncateTooltipDirective];

const providers: Provider[] = [
  CacheService,
  ImageProviderService,
  LoggerService,
  NotificationHandlerService,
  ModuleConfigService,
  LangInterceptorService,
  MiningToastService,
  MiningToastManagerService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LangInterceptorService,
    multi: true,
  },
];

@NgModule({
  declarations: [
    AppComponent,
    ...COMPONENTS,
    ...PIPES,
    ...DIRECTIVES,
    MainTableComponent,
    DataTableComponent,
    RegisterPerPageComponent,
    PaginatorComponent,
    HeaderTableComponent,
  ],
  imports: [CommonModule, HttpClientModule, NgbModule, ReactiveFormsModule, FormsModule, NgSelectModule],
  providers,
  exports: [...COMPONENTS, ...PIPES, DIRECTIVES],
  bootstrap: [AppComponent],
})
export class AppModule {}

@NgModule({})
export class Common2Module {
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule,
      providers,
    };
  }
}
